import { configureStore } from "@reduxjs/toolkit";
import { assetsReducer } from "./reducers/assets";
import { templateReducer } from "./reducers/template";
import { contentReducer } from "./reducers/contents";

export default configureStore({
  reducer: {
    assets: assetsReducer,
    templates: templateReducer,
    content: contentReducer,
  },
});
